module.exports = __webpack_public_path__ + "static/media/avolon_logo.e54d619c.png";